<div class="text-center" mat-dialog-content>
  <i
    class="d-inline-block icon-exclamation-triangle fs-80 icon-exclamation-triangle text-bluey-grey mb-1-5"
  ></i>
  <p>{{ data.data.errorDescription }}</p>
  <button class="btn btn-primary mt-4" (click)="dialogRef.close()">
    <span *scText="data.fields.SubmitButtonLabel"></span>
  </button>
</div>
